import React, { Component } from "react";
import config from "./../../common/config";
import core from "./../../common/core";
import Popup from "./../../componentsReusable/popup";
import Trans from "./../../componentsReusable/trans";
import Overlay from "./../../componentsReusable/Overlay";

let setTimeoutObj = null;
class OverlayAlertTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  showHideAlert = () => {
    this.props.showHideAlertTeam(false, "", "", "");
  };
  render() {
    let self = this;
    const { showHideAlert, props } = self;
    let { titleText, bodyText, bodyText1, sClass, isShow, hideHeader } = props;
    const onClickClose = {
      onClick: () => {
        showHideAlert();
      },
    };
    return (
      <Overlay
        className="m11c-overlay--transfer m11c-overlay--transfer-toast"
        isShow={isShow}
        showHideAlert={showHideAlert}
      >
        {!hideHeader && (
          <>
            <div className="m11c-overlay__header">
              <div className="m11c-overlay__title">
                <span>{titleText}</span>
              </div>
              <div className="m11c-overlay__close" {...onClickClose}>
                <i className="m11ci-close"></i>
              </div>
            </div>
          </>
        )}
        <div className="m11c-overlay__body">
          <div className="m11c-transfer__icon">
            <img alt="" src={config.IMG_BASE + "success-icon.png"} />
          </div>

          {hideHeader && (
            <>
              <div className="m11c-overlay__title">
                <span>{titleText}</span>
              </div>
            </>
          )}

          <div className="m11c-transfer__content">
            <span>{bodyText}</span>
            <span>{bodyText1}</span>
          </div>
        </div>
        <div className="m11c-overlay__foot">
          <ul>
            <li>
              <div className="m11c-btn m11c-btn__primary" {...onClickClose}>
                <span>
                  <Trans sKey={"okay"} />
                </span>
              </div>
            </li>
          </ul>
        </div>
      </Overlay>
    );
  }
}
export default OverlayAlertTeam;
